import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Get XP required for next level (5E 2024 XP thresholds)
 */
export function getXpForNextLevel(currentLevel: number): number {
  const xpThresholds: Record<number, number> = {
    1: 300,
    2: 900,
    3: 2700,
    4: 6500,
    5: 14000,
    6: 23000,
    7: 34000,
    8: 48000,
    9: 64000,
    10: 85000,
    11: 100000,
    12: 120000,
    13: 140000,
    14: 165000,
    15: 195000,
    16: 225000,
    17: 265000,
    18: 305000,
    19: 355000,
    20: 999999,
  };
  return xpThresholds[currentLevel] ?? xpThresholds[20];
}

/** Format scene/location name for display.
 *  Dungeon scenes are authored as "{Location}: {Scene}" (e.g. "Upper Halls: The
 *  Guarded Stair"); the scene panel and transition line only have room for the
 *  scene part, so drop the location prefix.
 *  If the name looks like a raw ID (contains underscores), replace them and Title Case.
 *  Otherwise return as-is (module-resolved names are already properly cased). */
export function formatSceneName(name: string): string {
  if (!name) return name;
  const sep = name.indexOf(': ');
  if (sep !== -1) return name.slice(sep + 2);
  if (!name.includes('_')) return name;
  return name
    .replace(/_/g, ' ')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
